// import { gql } from '@apollo/client';
import gql from 'graphql-tag';

export const SITE_INFORMATION_QUERY = gql`
  query SiteInformation($siteName: String!) {
    siteInfo(filters: { site: { name: { iContains: $siteName } } }) {
      site {
        name
        title
        id
        appUrl
        version
      }
      theme {
        name
        id
      }
      logo {
        name
        id
      }
      favicon {
        name
        id
      }
    }
  }
`;
export const LOGO_QUERY = gql`
  query LogoQuery {
    logos {
      isActive
      id
      imageFile {
        url
      }
      size
      theme {
        name
      }
      title
    }
  }
`;

export const PAGE_INFORMATION_QUERY = gql`
  query PageInformationQuery($sidebarURL: String!) {
    pageConn(filters: { sidebarUrl: { iContains: $sidebarURL } }) {
      edges {
        node {
          __typename
          id
          name
          title
          slug
          description
          content
          subContent
          icon {
            iconFile
          }
        }
      }
    }
  }
`;

export const OTHER_APPS_QUERY = gql`
  query OtherApps {
    otherApps(filters: { visibleInMenu: true }) {
      id
      name
      title
      icon {
        name
        iconFile
      }
      url
      appCategory {
        name
      }
      description
    }
  }
`;

export const ALL_THEMES_QUERY = gql`
  query AllThemesQuery {
    themeList {
      id
      name
      title
    }
  }
`;

export const THEME_OBJECT_QUERY = gql`
  query ThemeObjectQuery($theme: String!) {
    themeList(filters: { name: { iContains: $theme } }) {
      __typename
      name
      props
      colorScheme {
        __typename
        primaryContrastColor
        primaryTextColor
        primaryMainColor
        secondaryContrastColor
        secondaryMainColor
        secondaryTextColor
        errorColor
        id
        background
        titleBarMainColor
        titleBarContrastColor
        title
      }
      typography {
        __typename
        fontSize
        fontWeight
        id
        letterSpacing
        name
      }
    }
  }
`;

export const ALL_LAYOUTS_QUERY = gql`
  query AllLayoutsQuery {
    layoutList {
      __typename
      id
      name
      title
    }
  }
`;

// export const ROUTES_MPTT_QUERY = gql`
// query RoutesMPTT($authentication: Boolean, $reqNodeName: String, $sidebar: Boolean, $isActive: Boolean = true, $level: Int) {
//   defaultRoutesMptt {
//     __typename
//     id
//     name
//     title
//     level
//     slug
//     visible
//     displayOrder
//     icon {
//       __typename
//       id
//       name
//       iconFile
//       title
//     }
//     parent {
//       __typename
//       id
//       name
//       title
//     }
//     pages(filters: {sidebar: $sidebar, authentication: $authentication, isActive: $isActive}) {
//       __typename
//       id
//       name
//       title
//       slug
//       authentication
//       sidebarUrl
//       sidebarOrder
//       icon {
//         __typename
//         name
//         id
//         iconFile
//         iconUrl
//         title
//       }
//       component {
//         __typename
//         name
//         id
//       }
//       subPages {
//         __typename
//         id
//         name
//         title
//         slug
//         url
//         sortOrder
//         icon {
//           __typename
//           name
//           id
//           iconFile
//           iconUrl
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//       }
//     }
//   }
//   appRoutesMptt(
//     filters: {authentication: $authentication, sidebar: $sidebar, level: {exact: $level}}
//     reqNodeName: $reqNodeName
//   ) {
//     __typename
//     id
//     name
//     title
//     level
//     slug
//     visible
//     displayOrder
//     icon {
//       __typename
//       id
//       name
//       iconFile
//       title
//     }
//     parent {
//       __typename
//       id
//       name
//       title
//     }
//     children(filters: {authentication: $authentication, sidebar: $sidebar}) {
//       __typename
//       id
//       name
//       title
//       level
//       slug
//       displayOrder
//       icon {
//         __typename
//         name
//         id
//         iconFile
//         title
//       }
//       pages(filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive}) {
//         __typename
//         id
//         name
//         title
//         slug
//         authentication
//         sidebarUrl
//         sidebarOrder
//         icon {
//           __typename
//           id
//           name
//           iconFile
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//         subPages {
//           __typename
//           id
//           name
//           title
//           slug
//           url
//           sortOrder
//           icon {
//             __typename
//             name
//             id
//             iconFile
//             iconUrl
//             title
//           }
//           component {
//             __typename
//             id
//             name
//           }
//         }
//       }
//     }
//   }
// }
// `;

// export const ROUTES_MPTT_QUERY = gql`
// query RoutesMPTT($authentication: Boolean, $reqNodeName: String, $sidebar: Boolean, $isActive: Boolean = true, $level: Int) {
//   defaultRoutesMptt {
//     __typename
//     id
//     name
//     title
//     level
//     slug
//     visible
//     displayOrder
//     icon {
//       __typename
//       id
//       name
//       iconFile
//       title
//     }
//     parent {
//       __typename
//       id
//       name
//       title
//     }
//     pages(filters: {sidebar: $sidebar, authentication: $authentication, isActive: $isActive}) {
//       __typename
//       id
//       name
//       title
//       slug
//       authentication
//       sidebarUrl
//       sidebarOrder
//       icon {
//         __typename
//         name
//         id
//         iconFile
//         iconUrl
//         title
//       }
//       component {
//         __typename
//         name
//         id
//       }
//       subPages {
//         __typename
//         id
//         name
//         title
//         slug
//         url
//         sortOrder
//         icon {
//           __typename
//           name
//           id
//           iconFile
//           iconUrl
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//       }
//     }
//   }
//   appRoutesMptt(
//     filters: {authentication: $authentication, sidebar: $sidebar, level: {exact: $level}}
//     reqNodeName: $reqNodeName
//   ) {
//     __typename
//     id
//     name
//     title
//     level
//     slug
//     visible
//     displayOrder
//     icon {
//       __typename
//       id
//       name
//       iconFile
//       title
//     }
//     parent {
//       __typename
//       id
//       name
//       title
//     }
//     pages(filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive}) {
//         __typename
//         id
//         name
//         title
//         slug
//         authentication
//         sidebarUrl
//         sidebarOrder
//         isPbiPage
//         pbiEmbedUrl
//         icon {
//           __typename
//           id
//           name
//           iconFile
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//         subPages {
//           __typename
//           id
//           name
//           title
//           slug
//           url
//           sortOrder
//           icon {
//             __typename
//             name
//             id
//             iconFile
//             iconUrl
//             title
//           }
//           component {
//             __typename
//             id
//             name
//           }
//         }
//       }
//     children(filters: {authentication: $authentication, sidebar: $sidebar}) {
//       __typename
//       id
//       name
//       title
//       level
//       slug
//       displayOrder
//       icon {
//         __typename
//         name
//         id
//         iconFile
//         title
//       }
//       children(filters: {authentication: $authentication, sidebar: $sidebar}) {
//         __typename
//         id
//         name
//         title
//         level
//         slug
//         displayOrder
//         icon {
//           __typename
//           name
//           id
//           iconFile
//           title
//         }
//         pages(filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive}) {
//         __typename
//         id
//         name
//         title
//         slug
//         authentication
//         sidebarUrl
//         sidebarOrder
//         isPbiPage
//         pbiEmbedUrl
//         icon {
//           __typename
//           id
//           name
//           iconFile
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//         subPages {
//           __typename
//           id
//           name
//           title
//           slug
//           url
//           sortOrder
//           icon {
//             __typename
//             name
//             id
//             iconFile
//             iconUrl
//             title
//           }
//           component {
//             __typename
//             id
//             name
//           }
//         }
//       }
//     	}
//       pages(filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive}) {
//         __typename
//         id
//         name
//         title
//         slug
//         authentication
//         sidebarUrl
//         sidebarOrder
//         isPbiPage
//         pbiEmbedUrl
//         icon {
//           __typename
//           id
//           name
//           iconFile
//           title
//         }
//         component {
//           __typename
//           id
//           name
//         }
//         subPages {
//           __typename
//           id
//           name
//           title
//           slug
//           url
//           sortOrder
//           icon {
//             __typename
//             name
//             id
//             iconFile
//             iconUrl
//             title
//           }
//           component {
//             __typename
//             id
//             name
//           }
//         }
//       }
//     }
//   }
// }`

// export const ROUTES_MPTT_QUERY = gql`
  // query RoutesMPTT(
  //   $authentication: Boolean
  //   $reqNodeName: String
  //   $sidebar: Boolean
  //   $isActive: Boolean = true
  //   $level: Int
  //   $sourceId: Int
  // ) {
  //   defaultRoutesMptt {
  //     __typename
  //     id
  //     name
  //     title
  //     level
  //     slug
  //     visible
  //     displayOrder
  //     icon {
  //       __typename
  //       id
  //       name
  //       iconFile
  //       title
  //     }
  //     parent {
  //       __typename
  //       id
  //       name
  //       title
  //     }
  //     pages(
  //       filters: {
  //         sidebar: $sidebar
  //         authentication: $authentication
  //         isActive: $isActive
  //       }
  //     ) {
  //       __typename
  //       id
  //       name
  //       title
  //       slug
  //       authentication
  //       sidebarUrl
  //       sidebarOrder
  //       icon {
  //         __typename
  //         name
  //         id
  //         iconFile
  //         iconUrl
  //         title
  //       }
  //       component {
  //         __typename
  //         name
  //         id
  //       }
  //       subPages {
  //         __typename
  //         id
  //         name
  //         title
  //         slug
  //         url
  //         sortOrder
  //         icon {
  //           __typename
  //           name
  //           id
  //           iconFile
  //           iconUrl
  //           title
  //         }
  //         component {
  //           __typename
  //           id
  //           name
  //         }
  //       }
  //     }
  //   }
  //   appRoutesMptt(
  //     filters: {
  //       authentication: $authentication
  //       sidebar: $sidebar
  //       level: { exact: $level }
  //     }
  //     reqNodeName: $reqNodeName
  //     sourceId: $sourceId
  //   ) {
  //     __typename
  //     id
  //     name
  //     title
  //     level
  //     slug
  //     visible
  //     displayOrder
  //     icon {
  //       __typename
  //       id
  //       name
  //       iconFile
  //       title
  //     }
  //     parent {
  //       __typename
  //       id
  //       name
  //       title
  //     }
  //     pages(
  //       filters: {
  //         authentication: $authentication
  //         sidebar: $sidebar
  //         isActive: $isActive
  //       }
  //     ) {
  //       __typename
  //       id
  //       name
  //       title
  //       slug
  //       authentication
  //       sidebarUrl
  //       sidebarOrder
  //       isPbiPage
  //       pbiEmbedUrl
  //       icon {
  //         __typename
  //         id
  //         name
  //         iconFile
  //         title
  //       }
  //       component {
  //         __typename
  //         id
  //         name
  //       }
  //       subPages {
  //         __typename
  //         id
  //         name
  //         title
  //         slug
  //         url
  //         sortOrder
  //         icon {
  //           __typename
  //           name
  //           id
  //           iconFile
  //           iconUrl
  //           title
  //         }
  //         component {
  //           __typename
  //           id
  //           name
  //         }
  //       }
  //     }
  //     children(
  //       filters: { authentication: $authentication, sidebar: $sidebar }
  //     ) {
  //       __typename
  //       id
  //       name
  //       title
  //       level
  //       slug
  //       displayOrder
  //       icon {
  //         __typename
  //         name
  //         id
  //         iconFile
  //         title
  //       }
  //       children(
  //         filters: { authentication: $authentication, sidebar: $sidebar }
  //       ) {
  //         __typename
  //         id
  //         name
  //         title
  //         level
  //         slug
  //         displayOrder
  //         icon {
  //           __typename
  //           name
  //           id
  //           iconFile
  //           title
  //         }
  //         pages(
  //           filters: {
  //             authentication: $authentication
  //             sidebar: $sidebar
  //             isActive: $isActive
  //           }
  //         ) {
  //           __typename
  //           id
  //           name
  //           title
  //           slug
  //           authentication
  //           sidebarUrl
  //           sidebarOrder
  //           isPbiPage
  //           pbiEmbedUrl
  //           icon {
  //             __typename
  //             id
  //             name
  //             iconFile
  //             title
  //           }
  //           component {
  //             __typename
  //             id
  //             name
  //           }
  //           subPages {
  //             __typename
  //             id
  //             name
  //             title
  //             slug
  //             url
  //             sortOrder
  //             icon {
  //               __typename
  //               name
  //               id
  //               iconFile
  //               iconUrl
  //               title
  //             }
  //             component {
  //               __typename
  //               id
  //               name
  //             }
  //           }
  //         }
  //       }
  //       pages(
  //         filters: {
  //           authentication: $authentication
  //           sidebar: $sidebar
  //           isActive: $isActive
  //         }
  //       ) {
  //         __typename
  //         id
  //         name
  //         title
  //         slug
  //         authentication
  //         sidebarUrl
  //         sidebarOrder
  //         isPbiPage
  //         pbiEmbedUrl
  //         icon {
  //           __typename
  //           id
  //           name
  //           iconFile
  //           title
  //         }
  //         component {
  //           __typename
  //           id
  //           name
  //         }
  //         subPages {
  //           __typename
  //           id
  //           name
  //           title
  //           slug
  //           url
  //           sortOrder
  //           icon {
  //             __typename
  //             name
  //             id
  //             iconFile
  //             iconUrl
  //             title
  //           }
  //           component {
  //             __typename
  //             id
  //             name
  //           }
  //         }
  //       }
  //     }
  //   }
  // }
// `;


export const ROUTES_MPTT_QUERY = gql`
query RoutesMPTT($authentication: Boolean, $reqNodeName: String, $sidebar: Boolean, $isActive: Boolean = true, $level: Int,$sourceId: ID) {
  defaultRoutesMptt {
    __typename
    id
    name
    title
    level
    slug
    visible
    displayOrder
    icon {
      __typename
      id
      name
      iconFile
      title
    }
    parent {
      __typename
      id
      name
      title
    }
    pages(
      filters: {sidebar: $sidebar, authentication: $authentication, isActive: $isActive}
    ) {
      __typename
      id
      name
      title
      slug
      authentication
      sidebarUrl
      sidebarOrder
	  source {
            alias
            name
            pkId
          }
      icon {
        __typename
        name
        id
        iconFile
        iconUrl
        title
      }
      component {
        __typename
        name
        id
      }
      subPages {
        __typename
        id
        name
        title
        slug
        url
        sortOrder
        icon {
          __typename
          name
          id
          iconFile
          iconUrl
          title
        }
        component {
          __typename
          id
          name
        }
      }
    }
  }
  appRoutesMptt(
    filters: {authentication: $authentication, sidebar: $sidebar, level: {exact: $level}}
    reqNodeName: $reqNodeName
  ) {
    __typename
    id
    name
    title
    level
    slug
    visible
    displayOrder
    icon {
      __typename
      id
      name
      iconFile
      title
    }
    parent {
      __typename
      id
      name
      title
    }
    pages(
      filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive, sourceId: {pkId: {exact: $sourceId}}}
    ) {
      __typename
      id
      name
      title
      slug
      authentication
      sidebarUrl
      sidebarOrder
      isPbiPage
      pbiEmbedUrl
	  source {
            alias
            name
            pkId
          }
      icon {
        __typename
        id
        name
        iconFile
        title
      }
      component {
        __typename
        id
        name
      }
      subPages {
        __typename
        id
        name
        title
        slug
        url
        sortOrder
        icon {
          __typename
          name
          id
          iconFile
          iconUrl
          title
        }
        component {
          __typename
          id
          name
        }
      }
    }
    children(filters: {authentication: $authentication, sidebar: $sidebar}) {
      __typename
      id
      name
      title
      level
      slug
      displayOrder
      icon {
        __typename
        name
        id
        iconFile
        title
      }
      children(filters: {authentication: $authentication, sidebar: $sidebar}) {
        __typename
        id
        name
        title
        level
        slug
        displayOrder
        icon {
          __typename
          name
          id
          iconFile
          title
        }
        pages(
          filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive, sourceId: {pkId: {exact: $sourceId}}}
        ) {
          __typename
          id
          name
          title
          slug
          authentication
          sidebarUrl
          sidebarOrder
          isPbiPage
          pbiEmbedUrl
		  source {
            alias
            name
            pkId
          }
          icon {
            __typename
            id
            name
            iconFile
            title
          }
          component {
            __typename
            id
            name
          }
          subPages {
            __typename
            id
            name
            title
            slug
            url
            sortOrder
            icon {
              __typename
              name
              id
              iconFile
              iconUrl
              title
            }
            component {
              __typename
              id
              name
            }
          }
        }
      }
      pages(
        filters: {authentication: $authentication, sidebar: $sidebar, isActive: $isActive, sourceId: {pkId: {exact: $sourceId}}}
      ) {
        __typename
        id
        name
        title
        slug
        authentication
        sidebarUrl
        sidebarOrder
        isPbiPage
        pbiEmbedUrl
		source {
            alias
            name
            pkId
          }
        icon {
          __typename
          id
          name
          iconFile
          title
        }
        component {
          __typename
          id
          name
        }
        subPages {
          __typename
          id
          name
          title
          slug
          url
          sortOrder
          icon {
            __typename
            name
            id
            iconFile
            iconUrl
            title
          }
          component {
            __typename
            id
            name
          }
        }
      }
    }
  }
}`